import { render, staticRenderFns } from "./img-container.vue?vue&type=template&id=48589cc0&scoped=true"
import script from "./img-container.vue?vue&type=script&lang=js"
export * from "./img-container.vue?vue&type=script&lang=js"
import style0 from "./img-container.vue?vue&type=style&index=0&id=48589cc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48589cc0",
  null
  
)

export default component.exports